<template>
  <div class="home">
    <img src="~@/img/logo_main.png" alt="Les mystères de pékin" @click="goPlay">

    <router-link to="choisir-son-personnage" class="home-btn btn">Jouer</router-link>
  </div>
</template>

<script>
  import Transition from '~mixins/Transition';

  export default {
    name: 'home',
    mixins: [Transition],
    methods: {
      goPlay() {
        this.$router.push('choisir-son-personnage');
      },
    },
  };
</script>


<style lang="scss">
  .home {
    position: relative;
    width: 100%;
    transition: opacity .5s ease;

    .app-content {
      padding-bottom: 50px;
    }

    &.leave {
      opacity: 0;
    }

    img {
      display: block;
      margin: auto;
      max-width: 80%;
      opacity: 0;
      animation: fadeInHome .5s ease forwards;
      cursor: pointer;
    }

    @keyframes fadeInHome {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    .app-header--logo {
      img {
        @include mobile {
          max-width: 100%;
        }
      }
    }

    .home-btn {
      position: absolute;
      bottom: -110px;
      left: 50%;
      text-transform: uppercase;
      text-decoration: none;
      font-weight: bold;
      padding: 3px 40px;
      opacity: 0;
      animation: translateXHomeBtn .6s 1s ease-in-out forwards;
      @include fontSize(35);

      @include mobile {
        @include fontSize(20);
      }
    }

    @keyframes translateXHomeBtn {
      from {
        opacity: 0;
        transform: translateY(30px) translateX(-50%);
      }
      to {
        opacity: 1;
        transform: translateY(0) translateX(-50%);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?4bce9fab